import { Route } from '@angular/router';
import { HomeComponent } from './home.component';
import { UserAuthGuardService } from '../../services/user-auth-guard.service';

export const HomeRoutes: Route[] = [
    {
      path: '',
      component: HomeComponent,
      canActivate: [UserAuthGuardService],

    },
];



// WEBPACK FOOTER //
// ./src/app/corp/home/home.routes.ts